"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onCellClickedFactory = void 0;
var ts_invariant_1 = require("ts-invariant");
var dataSourceUtils_1 = require("../data/dataSourceUtils");
var tableDescriptorTypes_1 = require("../structure/tableDescriptorTypes");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var cellDrillabilityPredicate_1 = require("../drilling/cellDrillabilityPredicate");
var drilledRowFactory_1 = require("../drilling/drilledRowFactory");
var drillIntersectionFactory_1 = require("../drilling/drillIntersectionFactory");
function onCellClickedFactory(table, props) {
    return function (cellEvent) {
        var _a, _b;
        ts_invariant_1.invariant(table.tableDescriptor);
        var row = cellEvent.data;
        ts_invariant_1.invariant(row);
        if (dataSourceUtils_1.isSomeTotal(row.type)) {
            return false;
        }
        var colDef = cellEvent.colDef, data = cellEvent.data, rowIndex = cellEvent.rowIndex;
        var col = table.tableDescriptor.getCol(colDef);
        // cells belong to either slice column or leaf data column; if cells belong to column of a different
        // type then there must be either something messed up with table construction or a new type of cell
        ts_invariant_1.invariant(tableDescriptorTypes_1.isSliceCol(col) || tableDescriptorTypes_1.isSeriesCol(col));
        var onDrill = props.onDrill;
        var dv = table.getDrillDataContext();
        var drillablePredicates = sdk_ui_1.convertDrillableItemsToPredicates(props.drillableItems);
        var areDrillableHeaders = cellDrillabilityPredicate_1.isCellDrillable(col, cellEvent.data, dv, drillablePredicates);
        if (!areDrillableHeaders) {
            return false;
        }
        var drillContext = {
            type: sdk_ui_1.VisualizationTypes.TABLE,
            element: "cell",
            columnIndex: table.tableDescriptor.getAbsoluteLeafColIndex(col),
            rowIndex: rowIndex,
            row: drilledRowFactory_1.createDrilledRow(data, table.tableDescriptor),
            intersection: drillIntersectionFactory_1.createDrillIntersection(cellEvent, table.tableDescriptor),
        };
        var drillEvent = {
            dataView: dv.dataView,
            drillContext: drillContext,
        };
        if (onDrill === null || onDrill === void 0 ? void 0 : onDrill(drillEvent)) {
            // This is needed for /analyze/embedded/ drilling with post message
            // More info: https://github.com/gooddata/gdc-analytical-designer/blob/develop/test/drillEventing/drillEventing_page.html
            var event_1 = new CustomEvent("drill", {
                detail: drillEvent,
                bubbles: true,
            });
            (_b = (_a = cellEvent.event) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.dispatchEvent(event_1);
            return true;
        }
        return false;
    };
}
exports.onCellClickedFactory = onCellClickedFactory;
//# sourceMappingURL=onCellClick.js.map